import * as Yup from "yup";

import {
    validateSchema as _validateItemSchema,
    initialValues as _initialItemValues
} from "./itemSchema"

import {
    propFieldTypes as injectionPropFieldTypes
} from "../../../../hooks/api/useInjectionProps"

import {
    fieldDataTypes as injectionFieldDataTypes,
    moduleTypes as injectionFieldModuleTypes
} from "../../../../hooks/api/useInjectionFields"

export const validateItemSchema = _validateItemSchema
export const initialItemValues = _initialItemValues

export const productLoadStatusTypes = {
    pending: { // pending loaded to container
        id: "pending",
        value: "pending"
    },
    loaded: { // loaded container
        id: "loaded",
        value: "loaded"
    }
}

export const productImageTypes = {
    nfcImage: { // nfc image
        id: "nfcImage",
        typeValue: "nfcImage",
        tagValue: "nfcImage"
    },
    galleryImages: { // gallery images
        id: "galleryImages",
        typeValue: "galleryImages",
        tagValue: "galleryImages"
    }
}

const defCustomInjectionFields = { ref: injectionFieldModuleTypes.item.product.ref, module: injectionFieldModuleTypes.item.product.module }

export const customInjectionFields = {

    checkinDateTime: { submitKey: "checkin_datetime", retrieveKey: "inf_itm_prt_checkin_datetime", fieldDataTypeId: injectionFieldDataTypes.date_time.id, ...defCustomInjectionFields },

    loadStatus: { submitKey: "load_status", retrieveKey: "inf_itm_prt_load_status", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
    loadContainerId: { submitKey: "load_container_id", retrieveKey: "inf_itm_prt_load_container_id", fieldDataTypeId: injectionFieldDataTypes.id.id, ...defCustomInjectionFields },
    loadContainerDateTime: { submitKey: "load_container_datetime", retrieveKey: "inf_itm_prt_load_container_datetime", fieldDataTypeId: injectionFieldDataTypes.date_time.id, ...defCustomInjectionFields },
    customerMarking: { submitKey: "customer_marking", retrieveKey: "inf_itm_prt_customer_marking", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
    customerBranchId: { submitKey: "customer_branchid", retrieveKey: "inf_itm_prt_customer_branchid", fieldDataTypeId: injectionFieldDataTypes.id.id, ...defCustomInjectionFields },

    customerUserId: { submitKey: "customer_userid", retrieveKey: "inf_itm_prt_customer_userid", fieldDataTypeId: injectionFieldDataTypes.id.id, ...defCustomInjectionFields },
    supplierName: { submitKey: "supplier_name", retrieveKey: "inf_itm_prt_supplier_name", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
    supplierContact: { submitKey: "supplier_contact", retrieveKey: "inf_itm_prt_supplier_contact", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
    courierTrackingNo: { submitKey: "courier_tracking_no", retrieveKey: "inf_itm_prt_courier_tracking_no", fieldDataTypeId: injectionFieldDataTypes.text.id, ...defCustomInjectionFields },
    prepayDepositFee: { submitKey: "prepay_deposit_fee", retrieveKey: "inf_itm_prt_prepay_deposit_fee", fieldDataTypeId: injectionFieldDataTypes.numeric.id, ...defCustomInjectionFields },

    prepayTransportFee: { submitKey: "prepay_transport_fee", retrieveKey: "inf_itm_prt_prepay_transport_fee", fieldDataTypeId: injectionFieldDataTypes.numeric.id, ...defCustomInjectionFields },
    signedByUserId: { submitKey: "signed_by_user_id", retrieveKey: "inf_itm_prt_signed_by_user_id", fieldDataTypeId: injectionFieldDataTypes.id.id, ...defCustomInjectionFields },
    signedByUserDisplay: { submitKey: "signed_by_user_display", retrieveKey: "inf_itm_prt_signed_by_user_display", fieldDataTypeId: injectionFieldDataTypes.text.id, ...defCustomInjectionFields },
    remark: { submitKey: "remark", retrieveKey: "inf_itm_prt_remark", fieldDataTypeId: injectionFieldDataTypes.text.id, ...defCustomInjectionFields },
    paymentMethod: { submitKey: "payment_method", retrieveKey: "inf_itm_prt_payment_method", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },

    companyPurchaseNumber: { submitKey: "company_purchase_number", retrieveKey: "inf_itm_prt_company_purchase_number", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
    supplierPurchaseNumber: { submitKey: "supplier_purchase_number", retrieveKey: "inf_itm_prt_supplier_purchase_number", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
    barcode: { submitKey: "barcode", retrieveKey: "inf_itm_prt_barcode", fieldDataTypeId: injectionFieldDataTypes.text.id, ...defCustomInjectionFields },
    registerLocationId: { submitKey: "register_location_id", retrieveKey: "inf_itm_prt_register_location_id", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
    registerLocationDisplay: { submitKey: "register_location_display", retrieveKey: "inf_itm_prt_register_location_display", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },

    isSplit: { submitKey: "is_split", retrieveKey: "inf_itm_prt_is_split", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
    splitFromRemId: { submitKey: "split_from_remid", retrieveKey: "inf_itm_prt_split_from_remid", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
    nfcPersonName: { submitKey: "nfc_person_name", retrieveKey: "inf_itm_prt_nfc_person_name", fieldDataTypeId: injectionFieldDataTypes.text.id, ...defCustomInjectionFields },
    nfcIdentityNo: { submitKey: "nfc_identity_no", retrieveKey: "inf_itm_prt_nfc_identity_no", fieldDataTypeId: injectionFieldDataTypes.text.id, ...defCustomInjectionFields },
    nfcFileId: { submitKey: "nfc_file_id", retrieveKey: "inf_itm_prt_nfc_file_id", fieldDataTypeId: injectionFieldDataTypes.id.id, ...defCustomInjectionFields },

    nfcDetails: { submitKey: "nfc_details", retrieveKey: "inf_itm_prt_nfc_details", fieldDataTypeId: injectionFieldDataTypes.text.id, ...defCustomInjectionFields },
    sourceProductRemId: { submitKey: "source_product_remid", retrieveKey: "inf_itm_prt_source_product_remid", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },

    isAssignedDO: { submitKey: "is_assigned_do", retrieveKey: "inf_itm_prt_is_assigned_do", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
    assignedDONumber: { submitKey: "assigned_do_number", retrieveKey: "inf_itm_prt_assigned_do_number", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
    assignedDORemId: { submitKey: "assigned_do_remid", retrieveKey: "inf_itm_prt_assigned_do_remid", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },

    lastUpdateDatetime: { submitKey: "last_update_datetime", retrieveKey: "inf_itm_prt_last_update_datetime", fieldDataTypeId: injectionFieldDataTypes.date_time.id, ...defCustomInjectionFields },
    lastUpdateUserId: { submitKey: "last_update_user_id", retrieveKey: "inf_itm_prt_last_update_user_id", fieldDataTypeId: injectionFieldDataTypes.id.id, ...defCustomInjectionFields },
    lastUpdateUserDisplay: { submitKey: "last_update_user_display", retrieveKey: "inf_itm_prt_last_update_user_display", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },

    appPrintPackQty: { submitKey: "app_print_pack_qty", retrieveKey: "inf_itm_prt_app_print_pack_qty", fieldDataTypeId: injectionFieldDataTypes.numeric.id, ...defCustomInjectionFields },
    isAppEntry: { submitKey: "is_app_entry", retrieveKey: "inf_itm_prt_is_app_entry", fieldDataTypeId: injectionFieldDataTypes.integer.id, ...defCustomInjectionFields },

}

export const customInjectionPropsBk = {

    loadStatus: {
        submitKey: "load_status",
        retrieveKey: "inj_itm_prt_load_status",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        getValue: (val) => {
            return val
        }
    },
    loadContainerId: {
        submitKey: "load_container_id",
        retrieveKey: "inj_itm_prt_load_container_id",
        propFieldId: injectionPropFieldTypes.id.id,
        propFieldName: injectionPropFieldTypes.id.fieldName,
        getValue: (val) => {
            return val
        }
    },
    loadContainerDateTime: {
        submitKey: "load_container_datetime",
        retrieveKey: "inj_itm_prt_load_container_datetime",
        propFieldId: injectionPropFieldTypes.date_time.id,
        propFieldName: injectionPropFieldTypes.date_time.fieldName,
        getValue: (val) => {
            return val
        }
    },

    customerMarking: {
        submitKey: "customer_marking",
        retrieveKey: "inj_itm_prt_customer_marking",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        getValue: (val) => {
            return val
        }
    },
    customerBranchId: {
        submitKey: "customer_branchid",
        retrieveKey: "inj_itm_prt_customer_branchid",
        propFieldId: injectionPropFieldTypes.id.id,
        propFieldName: injectionPropFieldTypes.id.fieldName,
        getValue: (val) => {
            return val
        }
    },
    customerUserId: {
        submitKey: "customer_userid",
        retrieveKey: "inj_itm_prt_customer_userid",
        propFieldId: injectionPropFieldTypes.id.id,
        propFieldName: injectionPropFieldTypes.id.fieldName,
        getValue: (val) => {
            return val
        }
    },

    supplierName: {
        submitKey: "supplier_name",
        retrieveKey: "inj_itm_prt_supplier_name",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        getValue: (val) => {
            return val
        }
    },
    supplierContact: {
        submitKey: "supplier_contact",
        retrieveKey: "inj_itm_prt_supplier_contact",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        getValue: (val) => {
            return val
        }
    },

    courierTrackingNo: {
        submitKey: "courier_tracking_no",
        retrieveKey: "inj_itm_prt_courier_tracking_no",
        propFieldId: injectionPropFieldTypes.text.id,
        propFieldName: injectionPropFieldTypes.text.fieldName,
        getValue: (val) => {
            return val
        }
    },
    prepayDepositFee: {
        submitKey: "prepay_deposit_fee",
        retrieveKey: "inj_itm_prt_prepay_deposit_fee",
        propFieldId: injectionPropFieldTypes.numeric.id,
        propFieldName: injectionPropFieldTypes.numeric.fieldName,
        getValue: (val) => {
            return val
        }
    },
    prepayTransportFee: {
        submitKey: "prepay_transport_fee",
        retrieveKey: "inj_itm_prt_prepay_transport_fee",
        propFieldId: injectionPropFieldTypes.numeric.id,
        propFieldName: injectionPropFieldTypes.numeric.fieldName,
        getValue: (val) => {
            return val
        }
    },

    signedByUserId: {
        submitKey: "signed_by_user_id",
        retrieveKey: "inj_itm_prt_signed_by_user_id",
        propFieldId: injectionPropFieldTypes.id.id,
        propFieldName: injectionPropFieldTypes.id.fieldName,
        getValue: (val) => {
            return val
        }
    },
    signedByUserDisplay: {
        submitKey: "signed_by_user_display",
        retrieveKey: "inj_itm_prt_signed_by_user_display",
        propFieldId: injectionPropFieldTypes.text.id,
        propFieldName: injectionPropFieldTypes.text.fieldName,
        getValue: (val) => {
            return val
        }
    },

    remark: {
        submitKey: "remark",
        retrieveKey: "inj_itm_prt_remark",
        propFieldId: injectionPropFieldTypes.text.id,
        propFieldName: injectionPropFieldTypes.text.fieldName,
        getValue: (val) => {
            return val
        }
    },
    paymentMethod: {
        submitKey: "payment_method",
        retrieveKey: "inj_itm_prt_payment_method",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        getValue: (val) => {
            return val
        }
    },
    companyPurchaseNumber: {
        submitKey: "company_purchase_number",
        retrieveKey: "inj_itm_prt_company_purchase_number",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        getValue: (val) => {
            return val
        }
    },
    supplierPurchaseNumber: {
        submitKey: "supplier_purchase_number",
        retrieveKey: "inj_itm_prt_supplier_purchase_number",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        getValue: (val) => {
            return val
        }
    },
    barcode: {
        submitKey: "barcode",
        retrieveKey: "inj_itm_prt_barcode",
        propFieldId: injectionPropFieldTypes.text.id,
        propFieldName: injectionPropFieldTypes.text.fieldName,
        getValue: (val) => {
            return val
        }
    },

    registerLocationId: {
        submitKey: "register_location_id",
        retrieveKey: "inj_itm_prt_register_location_id",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        getValue: (val) => {
            return val
        }
    },
    registerLocationDisplay: {
        submitKey: "register_location_display",
        retrieveKey: "inj_itm_prt_register_location_display",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        getValue: (val) => {
            return val
        }
    },

    isSplit: {
        submitKey: "is_split",
        retrieveKey: "inj_itm_prt_is_split",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        getValue: (val) => {
            return val
        }
    },
    splitFromRemId: {
        submitKey: "split_from_remid",
        retrieveKey: "inj_itm_prt_split_from_remid",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        getValue: (val) => {
            return val
        }
    },

    // NFC Information
    nfcPersonName: {
        submitKey: "nfc_person_name",
        retrieveKey: "inj_itm_prt_nfc_person_name",
        propFieldId: injectionPropFieldTypes.text.id,
        propFieldName: injectionPropFieldTypes.text.fieldName,
        getValue: (val) => {
            return val
        }
    },
    nfcIdentityNo: {
        submitKey: "nfc_identity_no",
        retrieveKey: "inj_itm_prt_nfc_identity_no",
        propFieldId: injectionPropFieldTypes.text.id,
        propFieldName: injectionPropFieldTypes.text.fieldName,
        getValue: (val) => {
            return val
        }
    },
    nfcFileId: {
        submitKey: "nfc_file_id",
        retrieveKey: "inj_itm_prt_nfc_file_id",
        propFieldId: injectionPropFieldTypes.id.id,
        propFieldName: injectionPropFieldTypes.id.fieldName,
        getValue: (val) => {
            return val
        }
    },
    nfcDetails: {
        submitKey: "nfc_details",
        retrieveKey: "inj_itm_prt_nfc_details",
        propFieldId: injectionPropFieldTypes.text.id,
        propFieldName: injectionPropFieldTypes.text.fieldName,
        getValue: (val) => {
            return val
        }
    },

    // scheduler
    sourceProductRemId: {
        submitKey: "source_product_remid",
        retrieveKey: "inj_itm_prt_source_product_remid",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        propIsMultiple: 0,
        getValue: (val) => {
            return val
        }
    }
}

// temp override this
export const customInjectionProps = customInjectionFields

export const paymentTypes = {
    non: {
        id: "-",
        display: "-"
    },
    c: {
        id: "c",
        display: "C"
    },
    b: {
        id: "b",
        display: "B"
    }
}

export const cbmDividerByNo = 1000000

export const calculateCbmByDimension = ({ w, h, l }) => {
    let cbm = w * h * l / cbmDividerByNo
    // console.log('calculateCbmByDimension', cbm)
    // cbm = parseFloat(cbm).toFixed(4)
    // cbm = Math.round((cbm + Number.EPSILON) * 10000) / 10000
    cbm = Math.round((cbm + 1e-10) * 10000) / 10000
    // console.log('calculateCbmByDimension', cbm)
    return cbm
}

export const validationProductSchema = Yup.object({
    supplierName: Yup
        .string()
        .required("Required"),
    supplierContact: Yup
        .string()
        .required("Required"),
    supplierPurchaseNumber: Yup
        .string()
        .required("Required"),
    purchaseNumber: Yup
        .string()
        .required("Required"),
    courierTrackingNo: Yup
        .string()
        .required("Required"),
    paymentType: Yup
        .string()
        .required("Required"),
    prepaidDepositAmount: Yup
        .string()
        .required("Required"),
    prepaidTransportAmount: Yup
        .string()
        .required("Required"),
    signUserId: Yup
        .string()
        .required("Required"),
    // signUserDisplay: Yup
    //     .string()
    //     .required("Required"),
    // remark: Yup
    //     .string()
    //     .required("Required"),
    items: Yup.array().min(1, `Min 1 Item`).of(validateItemSchema),
})

export const validationSchema = Yup.object({
    locationId: Yup
        .string()
        .required("Required"),
    userId: Yup
        .string()
        .required("Required"),
    userDisplay: Yup
        .string()
        .required("Required"),
    userBranchId: Yup
        .string()
        .required("Required"),
    marking: Yup
        .string()
        .required("Required"),
    products: Yup.array().of(validationProductSchema),
})

export const initialProductValues = {
    // optional
    userId: "",
    userMarking: "",
    userBranchId: "",

    supplierName: "",
    supplierContact: "",
    supplierPurchaseNumber: "",
    purchaseNumber: "",
    courierTrackingNo: "",
    paymentType: paymentTypes.non.id,
    prepaidDepositAmount: "0",
    prepaidTransportAmount: "0",
    signUserId: "",
    signUserDisplay: "",
    remark: "",
    total: {
        weight: "",
        cbm: "",
        value: ""
    },
    items: [],
    barcode: ""
    // items: [
    //     initialItemValues,
    // ]
}

export const initialValues = {
    locationId: "",
    locationDisplay: "",
    userId: "",
    userDisplay: "",
    userBranchId: "",
    marking: "",
    products: [
        initialProductValues
    ]
}